import _objectSpread from "/Users/natebosscher1/Sites/terrain-group/webapp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { makeStyles } from "tss-react/mui";
import { CellFocusContext } from "../TableViewData";
import { useCallback, useContext, useEffect, useState } from "react";
import TableCell from "@mui/material/TableCell";
import { DateCell } from "./DateCell";
import { ValueCell } from "./ValueCell";
import { TextCell } from "./TextCell";
import { SelectFromListCell } from "./SelectFromListCell";
import { MoneyCell } from "./MoneyCell";
import { NumberCell } from "./NumberCell";
import { FloatCell } from "./FloatCell";
import { MoneyFloatCell } from "./MoneyFloatCell";
import { SelectEntityFromListCell } from "./SelectEntityFromListCell";
import { DateTimeCell } from "./DateTimeCell";
import { CheckboxCell } from "./CheckboxCell";
import { TimeCell } from "./TimeCell";
import { jsx as _jsx } from "react/jsx-runtime";
var useStyles = makeStyles()(function (theme) { return ({ tableCell: { height: 30 }, checkboxPadding: { padding: 0 } }); });
export function EditCell(props) {
    var _a = useState(false), editable = _a[0], setEditable = _a[1];
    var showEdit = useCallback(function () { setEditable(true); }, []);
    var focusChangeEmitter = useContext(CellFocusContext);
    useEffect(function () { var sub = focusChangeEmitter.subscribe(function (e) { if (e.index === props.index && e.row === props.rowId) {
        setEditable(true);
    } }); return function () { return sub.cancel(); }; }, [props.index, props.rowId, focusChangeEmitter]);
    var key = props.column.key;
    if (!key) {
        return /*#__PURE__*/ _jsx(Td, { children: /*#__PURE__*/ _jsx(ValueCell, { row: props.row, column: props.column, value: props.value }) }, "cell");
    }
    if (props.locked) {
        return /*#__PURE__*/ _jsx(Td, { children: /*#__PURE__*/ _jsx(ValueCell, { row: props.row, value: props.value, column: props.column, locked: true }) }, "cell");
    }
    if (!editable && props.column.type !== "bool") {
        return /*#__PURE__*/ _jsx(Td, { children: /*#__PURE__*/ _jsx(ValueCell, { row: props.row, value: props.value, column: props.column, onClick: showEdit }) }, "cell");
    }
    var defaultEditProps = { value: props.value, onCancel: function () { return setEditable(false); }, onChange: function (value, extra) {
            setEditable(false);
            var diff = {};
            if (props.column.type === "select-entity-from-list") {
                if (value) {
                    diff[key] = value.id;
                    diff[props.column.displayKey] = value.name;
                }
                else if (value === null) { // @ts-ignore
                    diff[key] = null; // @ts-ignore
                    diff[props.column.displayKey] = "";
                }
            }
            else {
                diff[key] = value;
            }
            props.onChange(function (old) { var newValue = Object.assign({}, old, diff); if (props.column.processChange) {
                return props.column.processChange(newValue);
            } return newValue; });
            if (!extra || !extra.tab)
                return;
            if (extra.tab === 1) {
                focusChangeEmitter.emit({ row: props.rowId, index: props.index + 1 });
                return;
            }
            if (extra.tab === -1) {
                focusChangeEmitter.emit({ row: props.rowId, index: props.index - 1 });
                return;
            }
        } };
    if (props.column.type === "date") {
        return /*#__PURE__*/ _jsx(Td, { children: /*#__PURE__*/ _jsx(DateCell, _objectSpread({}, defaultEditProps)) }, "cell");
    }
    if (props.column.type === "date-time") {
        return /*#__PURE__*/ _jsx(Td, { children: /*#__PURE__*/ _jsx(DateTimeCell, _objectSpread({}, defaultEditProps)) }, "cell");
    }
    if (props.column.type === "time") {
        return /*#__PURE__*/ _jsx(Td, { children: /*#__PURE__*/ _jsx(TimeCell, _objectSpread({}, defaultEditProps)) }, "cell");
    }
    if (props.column.type === "bool") {
        return /*#__PURE__*/ _jsx(Td, { children: /*#__PURE__*/ _jsx(CheckboxCell, _objectSpread({}, defaultEditProps)) }, "cell");
    }
    if (props.column.type === "money") {
        return /*#__PURE__*/ _jsx(Td, { children: /*#__PURE__*/ _jsx(MoneyCell, _objectSpread({}, defaultEditProps)) }, "cell");
    }
    if (props.column.type === "money-float") {
        return /*#__PURE__*/ _jsx(Td, { children: /*#__PURE__*/ _jsx(MoneyFloatCell, _objectSpread({}, defaultEditProps)) }, "cell");
    }
    if (props.column.type === "float") {
        return /*#__PURE__*/ _jsx(Td, { children: /*#__PURE__*/ _jsx(FloatCell, _objectSpread({}, defaultEditProps)) }, "cell");
    }
    if (props.column.type === "number") {
        return /*#__PURE__*/ _jsx(Td, { children: /*#__PURE__*/ _jsx(NumberCell, _objectSpread({}, defaultEditProps)) }, "cell");
    }
    if (props.column.type === "select-from-list") {
        return /*#__PURE__*/ _jsx(Td, { children: /*#__PURE__*/ _jsx(SelectFromListCell, _objectSpread({ listSource: props.column.listSource, strictList: props.column.strictList }, defaultEditProps)) }, "cell");
    }
    if (props.column.type === "select-entity-from-list") {
        return /*#__PURE__*/ _jsx(Td, { children: /*#__PURE__*/ _jsx(SelectEntityFromListCell, _objectSpread({ name: props.row[props.column.displayKey], listSource: props.column.listSource, strictList: props.column.strictList }, defaultEditProps)) }, "cell");
    }
    return /*#__PURE__*/ _jsx(Td, { children: /*#__PURE__*/ _jsx(TextCell, _objectSpread({}, defaultEditProps)) }, "cell");
}
function Td(props) { var styles = useStyles().classes; return /*#__PURE__*/ _jsx(TableCell, { className: styles.tableCell + " " + styles.checkboxPadding, children: props.children }); }
